<iframe class="frame" [src]="data.paymentUrl" frameBorder="0"></iframe>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">{{ 'cancel' | translate }}</button>
  <button mat-button (click)="onFeedbackClick()">{{ 'give_your_feedback' | translate }}</button>
</div>
